<template>
    <div class="otp-dialog">
      <div class="otp-dialog-overlay"></div>
      <div class="otp-dialog-content">
        <div class="header">
            <p class="heading">{{isRoleDialog ? 'Access level' : `${isRevokeClicked ? 'Revoke access' : 'Reactivate account'}`}}</p>
            <img alt="img" class="removeIcon" @click="onClose" src="../../assets/crossIcon.svg" />
        </div>
        <div v-if="apiErrorMessage"> 
            <div class="errorHeading">Error</div>
            <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
        </div>
        <p class="desc">
            {{isRoleDialog ? 'Changing the user type will modify the existing access permissions' : `Are you sure you want to ${isRevokeClicked ? 'revoke' : 'grant'} access to ${item.name}?` }}
        </p>
        <div v-if="isRoleDialog">
            <div class="label">User type</div>
            <select v-model="userType" class="role">
                <option selected :value="userType">{{roles[userType]}}</option>
            </select>
        </div>
        <div>
            <div  class="label">Reason*</div>
            <div class="content">
                <textarea class="textbox" :disabled="viewMode" style="height: 98px; resize: none" type="textarea" v-model="reason" @blur="validateReason" placeholder="Enter here" />
                <p v-if="reasonError" class="label" style="color: red">{{reasonError}}</p>
            </div>
        </div>
        <div style="margin-top: 16px; display: flex; justify-content: space-between">
            <div class="cancelBtn" @click="onClose">Cancel</div>
            <div v-if="!isRoleDialog && isRevokeClicked" style="background: #EB5757" class="submitBtn" @click="handleSubmit">Revoke</div>
            <div v-else class="submitBtn" @click="handleSubmit">Submit</div>
        </div>
      </div>
    </div>
</template>

<script>
import { roleTypes } from "@/constants"
import { updateAccountStatus, updateUserRole } from "@/services/selfServeService";


export default ({
    name: 'AccessDialog',
    props: {
        item: Object,
        isRoleDialog: Boolean,
        isRevokeClicked: Boolean
    },
    data() {
        return {
            roles: roleTypes,
            userType: this.item.role === 'OPS' ? 'SUPERADMIN' : 'OPS',
            reason: '',
            reasonError: null,
            apiErrorMessage: null
        }
    },
    mounted() {
        this.userType = this.item.role === 'OPS' ? 'SUPERADMIN' : 'OPS'
    },
    methods: {
        onClose() {
            this.$emit("closeDialog");
        },
        validateReason() {
            this.reasonError = (this.reason == "") ? 'Reason cannot be empty' : '';
        },
        handleSubmit() {
            this.validateReason();
            if(!this.reasonError) {
                if(this.isRoleDialog) {
                    const payload = {
                        email: this.item.email,
                        newRole: this.userType,
                        comments: this.reason
                    }
                    updateUserRole(payload)
                        .then(res => res.json())
                        .then(data => {
                            if(data.code == 200) {
                                this.onClose();
                                this.$emit("backClicked");
                            } else {
                                this.apiErrorMessage = data?.errors?.[0] || data?.message
                            }
                        })
                        .catch(error => {
                            this.apiErrorMessage = error?.errors?.[0] || error?.message
                        })
                } else {
                    const payload = {
                        email: this.item.email,
                        action: this.isRevokeClicked ? 'REVOKE' : 'REACTIVATE',
                        comments: this.reason
                    }
                    updateAccountStatus(payload)
                        .then(res => res.json())
                        .then(data => {
                            if(data.code == 200) {
                                this.onClose();
                                this.$emit("backClicked");
                            } else {
                                this.apiErrorMessage = data?.errors?.[0] || data?.message
                            }
                        })
                        .catch(error => {
                            this.apiErrorMessage = error?.errors?.[0] || error?.message
                        })
                }
            }
        }
    }
})
</script>

<style scoped>
.otp-dialog {
    font-family: Inter-Regular;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .otp-dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .otp-dialog-content {
    position: relative;
    background-color: #fff;
    padding: 20px 30px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
    width: 288px;
  }

  .role{
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 8px 14px;
    width: 100%;
    height: 40px;
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    color: #41434C;
    opacity: 0.8;
}

  .error{
    color: #EB5757;
  }

  .inactive{
    opacity: 0.5;
  }

  .active{
    cursor: pointer;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .removeIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    color: #707070;
  }
  .heading {
    font-size: 18px;
    font-weight: 600;
    line-height: 23.4px;
    text-align: center;
    color: #41434C;
  }
  .desc {
    font-size: 12px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;
    color: #5C5C5C;
  }
    .content{
        height: 100%;
    }
    .textbox{
        width: 260px;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        max-width: 260px;
    }
    .label{
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 16px;
    }
    .cancelBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #2E31BE;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        padding: 9.5px 16px;
        width: 100px;
        cursor: pointer;
    }
    .submitBtn {
        background: #2E31BE;
        border-radius: 4px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
        padding: 9.5px 16px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 700;
        border: none;
        width: 100px;
    }
    .errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
    margin-bottom: 24px;
}
</style>